import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Layout, Menu, Popover, Spin } from 'antd';
import SettingsModal from '../SettingsModal';
import Toast from '../Toast';
import CurrencyDropdown from '../../components/CurrencyDropdown';
import {
  Logout,
  MenuTitleDescContainer,
  MenuTitleDescRow,
  PlanUsagePopover,
  SettingsButtonsContainer,
  StyledMenuItem,
  StyledMenuTitle,
  StyledMenuTitleValue,
  SalefreaksStyledMenu,
  SalefreaksStyledMenuItem,
} from './styled';
import { SanityCheck } from '../../components/SanityCheck';
import { ButtonWithIcon } from '../../components/common/ButtonWithIcon';
import colorNames from '../../constants/sanityCheck/color-names';
import iconNames from '../../constants/sanityCheck/icon-names';
import ENUMS from '../../constants/enums';
import { commaFormat } from '../../utils/numberCommaFormatter';
import {
  BalanceModal,
  BalanceStatusModal,
  LoadBalanceModalPayoneer,
  LoadBalanceModalPaypal,
} from '../../components/BalanceModals';
import { colors } from '../../constants';
import IconSvg from '../../components/common/IconSvg';
import { NoSubscriptionBlocker } from '../../components/NoSubscriptionBlocker';
import { NotificationsMenu } from '../../components/NotificationsMenu';
import TmModal from '../../components/common/TmModal';
import { getSignByProfitType } from '../../utils/parsers';
import BifmSettingsModal from '../Bifm/BifmSettingsModal';
import IconPng from '../../components/common/IconPng';

const { Header: AntHeader } = Layout;

const BALANCE_MODALS = {
  BALANCE: 1,
  BALANCE_STATUS: 2,
  LOAD_BALANCE_PAYPAL: 3,
  LOAD_BALANCE_PAYONEER: 4,
};

const statusMessages = {
  '0': 'subscription.withinLimits',
  '1': 'subscription.noPlan',
  '2': 'subscription.closeToLimits',
  '3': 'subscription.overLimit',
};
const newColors = { ...colorNames, '1': 'greySecondary' };

@injectIntl
@inject('localeStore')
@inject('toastsStore')
@inject('onboardingStore')
@inject('settingsStore')
@inject('sessionStore')
@inject('dashboardStore')
@inject('routingStore')
@inject('discoveryStore')
@inject('notificationsStore')
@observer
class SalefreaksHeader extends Component {
  constructor(props) {
    super(props);
    this.toggleSanityCheck = this.toggleSanityCheck.bind(this);
    // this.toggleSettings = this.toggleSettings.bind(this);
    this.toggleUserSettings = this.toggleUserSettings.bind(this);
    this.toggleBalance = this.toggleBalance.bind(this);
    this.toggleFinanceSettings = this.toggleFinanceSettings.bind(this);
    this.openBalanceStatus = this.openBalanceStatus.bind(this);
    this.openLoadBalancePaypal = this.openLoadBalancePaypal.bind(this);
    this.openLoadBalancePayoneer = this.openLoadBalancePayoneer.bind(this);
    this.openBalance = this.openBalance.bind(this);
    this.handleLoadBalanceInput = this.handleLoadBalanceInput.bind(this);
    this.setLoadSum = this.setLoadSum.bind(this);
    this.loadNow = this.loadNow.bind(this);
    this.hoverOn = this.hoverOn.bind(this);
    this.hoverOff = this.hoverOff.bind(this);
    this.state = {
      isSanityCheckOpen: false,
      activeBalanceModal: BALANCE_MODALS.BALANCE,
      isBalanceOpen: false,
      loadBalanceSum: 0,
      loadBalanceCommission: 0,
      loadBalanceCommissionPayoneer: 0,
      hoveringSanityCheck: false,
      hoveringUserProfile: false,
      planUsageVisible: null,
      userDeniedUpgradeToUnlimited: false,
    };
  }

  componentDidMount() {
    const { dashboardStore, onboardingStore } = this.props;
    const closedInLocalStorage = this.localStorageSanityClosed();
    dashboardStore.initStore().then(() => {
      if (
        !closedInLocalStorage && // sanity check should be open only the first time after login
        !this.state.isSanityCheckOpen &&
        dashboardStore.someRedAlert && // sanity check should not be open during tutorial
        !onboardingStore.tutorialEnabled // sanity check should not be open during tutorial
      ) {
        this.toggleSanityCheck();
        this.keepSanityClosed();
      }
    });
  }

  setLoadSum(howMuch) {
    this.setState({
      loadBalanceSum: howMuch,
      loadBalanceCommission: this.calculateCommission(howMuch),
      loadBalanceCommissionPayoneer: this.calculateCommissionPayoneer(howMuch),
    });
  }

  calculateCommission(value) {
    if (value < 100) {
      return 0.04 * value;
    } else if (value < 500) {
      return 0.03 * value;
    }
    return 0.025 * value;
  }

  calculateCommissionPayoneer(value) {
    return 0.01 * value;
  }

  toggleSanityCheck() {
    const {
      dashboardStore: { setSanityCheckOpen },
    } = this.props;
    setSanityCheckOpen(!this.state.isSanityCheckOpen);
    this.setState({
      isSanityCheckOpen: !this.state.isSanityCheckOpen,
    });
  }

  toggleBalance(activeBModal = BALANCE_MODALS.BALANCE) {
    const {
      settingsStore: {
        subscription: { currentPlanId, currentPlanFree },
      },
      sessionStore: { isBifmUser },
    } = this.props;
    if (!currentPlanId || currentPlanFree) {
      if (!isBifmUser) return;
    }
    this.setState({
      isBalanceOpen: !this.state.isBalanceOpen,
      activeBalanceModal: activeBModal,
    });
  }

  toggleUserSettings = () => {
    const {
      settingsStore: { toggleSettings },
    } = this.props;
    toggleSettings(ENUMS.SETTINGS_TABS.USER_PROFILE);
  };

  toggleFinanceSettings = () => {
    const {
      settingsStore: { toggleSettings },
    } = this.props;
    toggleSettings(ENUMS.SETTINGS_TABS.BALANCE);
  };

  openBalanceStatus() {
    this.setState({ isBalanceOpen: false }, () => {
      this.toggleBalance(BALANCE_MODALS.BALANCE_STATUS);
    });
  }

  openLoadBalancePaypal() {
    this.setState({ isBalanceOpen: false }, () => {
      this.toggleBalance(BALANCE_MODALS.LOAD_BALANCE_PAYPAL);
    });
  }

  openLoadBalancePayoneer() {
    this.setState({ isBalanceOpen: false }, () => {
      this.toggleBalance(BALANCE_MODALS.LOAD_BALANCE_PAYONEER);
    });
  }

  openBalance() {
    this.setState({ isBalanceOpen: false }, () => {
      this.toggleBalance(BALANCE_MODALS.BALANCE);
    });
  }

  handleLoadBalanceInput(e) {
    const givenValue = e.target ? e.target.value : 0;
    if (givenValue.indexOf('-') !== -1) {
      return;
    }
    const howMuch = parseFloat(givenValue) || 0;
    this.setState({
      loadBalanceSum: howMuch,
      loadBalanceCommission: this.calculateCommission(howMuch),
      loadBalanceCommissionPayoneer: this.calculateCommissionPayoneer(howMuch),
    });
  }

  loadNow = (nonce, pp_user) => {
    const {
      settingsStore: {
        balance: { depositCurrency },
        userProfile: { defaultCurrencyId },
      },
      toastsStore: { showToast },
    } = this.props;
    const { loadBalanceSum, loadBalanceCommission } = this.state;
    return depositCurrency(
      loadBalanceSum,
      loadBalanceCommission,
      defaultCurrencyId,
      nonce,
      pp_user,
    ).then(resp => {
      if (resp) {
        showToast({
          type: ENUMS.TOAST_TYPES.INFO,
          message: 'balance.balanceUpdated',
        });
      } else {
        showToast({
          type: ENUMS.TOAST_TYPES.WARNING,
          message: 'balance.balanceError',
        });
      }
      return resp;
    });
  };

  loadNowPayoneer = p_user => {
    const {
      settingsStore: {
        balance: { depositCurrencyPayoneer },
      },
      toastsStore: { showToast },
    } = this.props;
    const { loadBalanceSum, loadBalanceCommissionPayoneer } = this.state;
    return depositCurrencyPayoneer(
      loadBalanceSum,
      loadBalanceCommissionPayoneer,
      'USD',
      p_user,
    ).then(resp => {
      const {
        settingsStore: {
          balance: { payoneerSubmitResponse },
        },
      } = this.props;
      console.log(payoneerSubmitResponse);
      if (payoneerSubmitResponse.isOk === true || resp === true) {
        payoneerSubmitResponse.status !== 'error' &&
          showToast({
            type: ENUMS.TOAST_TYPES.INFO,
            message: 'balance.balanceUpdated',
          });
        payoneerSubmitResponse.status === 'error' &&
          showToast({
            type: ENUMS.TOAST_TYPES.WARNING,
            message:
              'There was an error connecting your Payoneer account. Please try again or contact support.',
          });
      } else {
        showToast({
          type: ENUMS.TOAST_TYPES.WARNING,
          message:
            typeof payoneerSubmitResponse.message === 'string'
              ? payoneerSubmitResponse.message
              : 'balance.balanceError',
        });
      }
      return resp;
    });
  };
  hoverOn(e, target = '') {
    e.preventDefault();
    e.stopPropagation();
    switch (target) {
      case 'userProfile': {
        this.setState({
          hoveringUserProfile: true,
        });
        break;
      }
      case 'sanityCheck': {
        this.setState({
          hoveringSanityCheck: true,
        });
        break;
      }
      default: {
        break;
      }
    }
  }
  hoverOff(e, target) {
    e.preventDefault();
    e.stopPropagation();
    switch (target) {
      case 'userProfile': {
        this.setState({
          hoveringUserProfile: false,
        });
        break;
      }
      case 'sanityCheck': {
        this.setState({
          hoveringSanityCheck: false,
        });
        break;
      }
      default: {
        break;
      }
    }
  }

  localStorageSanityClosed() {
    const sanityClosed = localStorage.getItem('sanityClosed');
    if (sanityClosed) {
      return true;
    }
    return false;
  }

  keepSanityClosed() {
    localStorage.setItem('sanityClosed', 'true');
  }

  localStoragePlanUsageClosed = () => {
    // return !!localStorage.getItem('planUsageClosed')
    return false;
  };

  keepPlanUsageClosed = () => {
    localStorage.setItem('planUsageClosed', 'true');
    this.handlePlanUsageVisibleChange(false);
  };

  handlePlanUsageVisibleChange = planUsageVisible => {
    this.setState({ planUsageVisible });
  };

  upgradeToUnlimited = () => {
    const {
      settingsStore: {
        subscription: { addHolidayFree, initSubscription },
      },
      toastsStore: { showToast },
    } = this.props;

    addHolidayFree().then(result => {
      if (result) {
        initSubscription().then(() => {
          this.hideUpgradeToUnlimitedModal();
        });
      } else {
        showToast({
          type: ENUMS.TOAST_TYPES.INFO,
          message: 'common.tryAgain',
        });
      }
    });
  };

  updateRouteState = path => {
    const {
      routingStore,
      notificationsStore: { fetchFirstPage },
    } = this.props;
    fetchFirstPage();
    if (window.location.pathname === path) {
      switch (path) {
        case '/discover/main': {
          routingStore.reloadDiscoverAndList();
          break;
        }
        case '/listings/table': {
          routingStore.reloadListings();
          break;
        }
        case '/orders/table': {
          routingStore.reloadOrders();
          break;
        }
        default: {
          break;
        }
      }
    }
    routingStore.browserHistory.push(path);
  };

  hideUpgradeToUnlimitedModal = () => {
    this.setState({ userDeniedUpgradeToUnlimited: true });
  };

  renderModal = currentPlanFree => {
    const { intl } = this.props;
    const { userDeniedUpgradeToUnlimited } = this.state;

    return (
      <React.Fragment>
        <TmModal
          type="darkBlue"
          title="Free Upgrade Available!"
          visible={!userDeniedUpgradeToUnlimited && currentPlanFree}
          mainActionBtn={{
            text: `${intl.formatMessage({ id: 'subscription.agree' })}`,
            clickHandler: () => {
              this.upgradeToUnlimited();
            },
          }}
          secondaryActionBtn={{
            text: `${intl.formatMessage({ id: 'common.dismiss' })}`,
            clickHandler: () => {
              this.hideUpgradeToUnlimitedModal();
            },
          }}
        >
          <h3>
            <FormattedMessage
              id="common.upgradeToUnlimitedPart1"
              default="Press here to get your FREE unlimited Holiday plan! Including unlimited listing plan, free auto-purchase subscription, free tracking conversion services!"
            />
          </h3>
          <h3>
            <FormattedMessage
              id="common.upgradeToUnlimitedPart2"
              default="Valid until January 31st 2021"
            />
          </h3>
        </TmModal>
      </React.Fragment>
    );
  };

  render() {
    const {
      dashboardStore,
      onboardingStore: { tutorialEnabled },
      sessionStore: { logout, isBifmUser },
      settingsStore: {
        subscription: { currentPlan, usagePercents, hasDoubleLimitsAddOn },
        userProfile: { firstName, email, defaultCurrencyId, isBetaUser },
        initialized,
        toggleSettings,
        isSettingsOpen,
        activeSettingsTab,
      },
      routingStore: { browserHistory },
      localeStore: { isJA },
    } = this.props;

    // get currency symbol to pass it to components directly
    const currency = getSignByProfitType(2, defaultCurrencyId);

    const changeRegion = region => {
      const {
        settingsStore: {
          userProfile: { updateCurrency },
        },
      } = this.props;
      if (/\/discover/.test(window.location.pathname)) {
        browserHistory.push('/discover/main');
      }
      if (/\/listings\/single-item/.test(window.location.pathname)) {
        browserHistory.push('/listings/table');
      }
      if (/\/orders\/single-item/.test(window.location.pathname)) {
        browserHistory.push('/listings/table');
      }
      updateCurrency(region);
    };

    const { miniDashboard } = dashboardStore;
    const {
      isSanityCheckOpen,
      isBalanceOpen,
      activeBalanceModal,
      loadBalanceSum,
      loadBalanceCommission,
      loadBalanceCommissionPayoneer,
      hoveringUserProfile,
      planUsageVisible,
    } = this.state;
    if (tutorialEnabled && isSanityCheckOpen) {
      this.toggleSanityCheck();
    }
    let loadedModal;
    if (isBalanceOpen) {
      switch (activeBalanceModal) {
        case BALANCE_MODALS.BALANCE:
          loadedModal = (
            <BalanceModal
              visible={isBalanceOpen}
              closeModal={this.toggleBalance}
              openLoadBalancePaypal={this.openLoadBalancePaypal}
              openLoadBalancePayoneer={this.openLoadBalancePayoneer}
              openBalanceStatus={this.openBalanceStatus}
              openFinanceSettings={this.toggleFinanceSettings}
              loadSum={loadBalanceSum}
              commission={loadBalanceCommission}
              commissionPayoneer={loadBalanceCommissionPayoneer}
              handleInput={this.handleLoadBalanceInput}
              setLoadSum={this.setLoadSum}
              currency={currency}
              isJA={isJA}
            />
          );
          break;
        case BALANCE_MODALS.BALANCE_STATUS:
          loadedModal = (
            <BalanceStatusModal
              visible={isBalanceOpen}
              closeModal={this.toggleBalance}
              openBalance={this.openBalance}
              openFinanceSettings={this.toggleFinanceSettings}
            />
          );
          break;
        case BALANCE_MODALS.LOAD_BALANCE_PAYPAL:
          loadedModal = (
            <LoadBalanceModalPaypal
              visible={isBalanceOpen}
              closeModal={this.toggleBalance}
              openBalanceStatus={this.openBalanceStatus}
              loadSum={loadBalanceSum}
              commission={loadBalanceCommission}
              openFinanceSettings={this.toggleFinanceSettings}
              loadNow={this.loadNow}
              currency={currency}
            />
          );
          break;
        case BALANCE_MODALS.LOAD_BALANCE_PAYONEER:
          loadedModal = (
            <LoadBalanceModalPayoneer
              visible={isBalanceOpen}
              closeModal={this.toggleBalance}
              openBalanceStatus={this.openBalanceStatus}
              loadSum={loadBalanceSum}
              commission={loadBalanceCommissionPayoneer}
              openFinanceSettings={this.toggleFinanceSettings}
              loadNow={this.loadNowPayoneer}
              currency={currency}
            />
          );
          break;
        default:
          loadedModal = null;
      }
    }

    let warningLevel = 0;
    const maxUsage = Math.max(usagePercents.autoPurchaseUsage, usagePercents.listedItemsUsage);

    if (currentPlan) {
      if (maxUsage >= 95 && maxUsage < 100) {
        warningLevel = 2;
      } else if (maxUsage >= 100) {
        warningLevel = 3;
      }
    } else {
      warningLevel = 1;
    }

    const { mobileLayout } = this.props;

    return (
      <Fragment>
        <Toast />
        {/* {this.renderModal(currentPlanFree)} */}
        <AntHeader
          css={{
            padding: 0,
            background: '#fff',
            height: 'auto',
            borderBottom: !mobileLayout && 'solid #e9eaef 1px',
          }}
        >
          <Menu
            mode="horizontal"
            css={{
              background: ' #ffffff',
              padding: 0,
              display: 'flex',
              height: '68px',
              // maxWidth: '1248px',
              width: '100%',
              margin: '0 auto',
              borderBottom: 'none',
              flexDirection: mobileLayout ? 'column' : 'row',
              alignItems: mobileLayout ? 'center' : 'stretch',
            }}
          >
            <StyledMenuItem key="header-item-0">
              <IconPng
                type="salefreaks-logo"
                size={128}
                onClick={() => this.updateRouteState('/')}
              />
            </StyledMenuItem>
            <StyledMenuItem
              key="header-item-1"
              style={{
                flexGrow: 0.1,
                border: mobileLayout && 'none',
                width: mobileLayout && '100%',
              }}
            >
              <CurrencyDropdown
                defaultValue={defaultCurrencyId}
                onChange={changeRegion}
                isBetaUser={isBetaUser}
                mobileLayout={mobileLayout}
              />
            </StyledMenuItem>
            <StyledMenuItem
              key="header-item-2"
              style={{
                flexGrow: 0.7,
                flexDirection: mobileLayout && 'column',
                border: mobileLayout && 'none',
                maxWidth: mobileLayout && '126px',
              }}
            >
              <SalefreaksStyledMenu
                mode="horizontal"
                defaultSelectedKeys={['1']}
                style={{ borderBottom: 'none' }}
              >
                <SalefreaksStyledMenuItem key="1" onClick={() => this.updateRouteState('/')}>
                  <IconSvg type="dashboard" size={20} marginRight="10px" />
                  <FormattedMessage id="common.dashboard" />
                </SalefreaksStyledMenuItem>
                <SalefreaksStyledMenuItem
                  key="2"
                  onClick={() => this.updateRouteState('/discover/main')}
                >
                  <IconSvg type="dashboard" size={20} marginRight="10px" />
                  <FormattedMessage id="common.salefreaks.discoverAndList" />
                </SalefreaksStyledMenuItem>
                <SalefreaksStyledMenuItem
                  key="3"
                  onClick={() => this.updateRouteState('/listings/table')}
                >
                  <IconSvg type="listings" size={20} marginRight="10px" />
                  <FormattedMessage id="common.salefreaks.listings" />
                </SalefreaksStyledMenuItem>

                <SalefreaksStyledMenuItem
                  key="4"
                  onClick={() => this.updateRouteState('/orders/table')}
                >
                  <IconSvg type="orders" size={20} marginRight="10px" />
                  <FormattedMessage id="common.orders" />
                </SalefreaksStyledMenuItem>

                <SalefreaksStyledMenuItem
                  key="5"
                  onClick={() => this.updateRouteState('/sourceAccounts')}
                >
                  <IconSvg type="orders" size={20} marginRight="10px" />
                  <FormattedMessage id="common.salefreaks.sourceAccounts" />
                </SalefreaksStyledMenuItem>

                <SalefreaksStyledMenuItem key="6" onClick={() => this.updateRouteState('/reports')}>
                  <IconSvg type="reports" size={20} marginRight="10px" />
                  <FormattedMessage id="common.reports" />
                </SalefreaksStyledMenuItem>
              </SalefreaksStyledMenu>
            </StyledMenuItem>
            <StyledMenuItem key="subscription">
              {!isBifmUser &&
                (initialized ? (
                  <Popover
                    content={
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          marginTop: maxUsage >= 95 ? '5px' : '0',
                        }}
                      >
                        {warningLevel && warningLevel !== 1 ? (
                          <PlanUsagePopover
                            statusMessage={statusMessages[warningLevel]}
                            openSubscriptionSettings={() =>
                              toggleSettings(ENUMS.SETTINGS_TABS.SUBSCRIPTION)
                            }
                            closeAction={this.keepPlanUsageClosed}
                          />
                        ) : (
                          <FormattedMessage id={statusMessages[warningLevel]} />
                        )}
                      </div>
                    }
                    defaultVisible={maxUsage >= 95}
                    // && !this.localStoragePlanUsageClosed()}
                    visible={planUsageVisible === null ? maxUsage >= 95 : planUsageVisible}
                    // && !this.localStoragePlanUsageClosed() : planUsageVisible}
                    onVisibleChange={this.handlePlanUsageVisibleChange}
                    title=""
                    placement={mobileLayout ? 'bottomRight' : 'bottom'}
                    mouseEnterDelay={mobileLayout ? 1 : 0}
                    trigger="hover"
                  >
                    <StyledMenuTitle
                      style={{ width: mobileLayout ? '100%' : '14%', cursor: 'pointer' }}
                      onClick={() => toggleSettings(ENUMS.SETTINGS_TABS.SUBSCRIPTION)}
                      hoverable
                      color={colors[newColors[warningLevel]]}
                      hoverColor={`${colors[newColors[warningLevel]]}BF`}
                    >
                      <StyledMenuTitleValue>
                        <IconSvg size={20} type={iconNames[warningLevel]} />
                      </StyledMenuTitleValue>
                      <MenuTitleDescContainer className="title-link">
                        <MenuTitleDescRow>
                          {currentPlan ? currentPlan.name : 'No Active Plan'}{' '}
                          {hasDoubleLimitsAddOn ? 'x 2' : ''}
                        </MenuTitleDescRow>
                      </MenuTitleDescContainer>
                    </StyledMenuTitle>
                  </Popover>
                ) : (
                  <StyledMenuTitle
                    style={{ width: mobileLayout ? '100%' : '14%', cursor: 'pointer' }}
                    onClick={() => toggleSettings(ENUMS.SETTINGS_TABS.SUBSCRIPTION)}
                    hoverable
                    color={colors[newColors[warningLevel]]}
                    hoverColor={`${colors[newColors[warningLevel]]}BF`}
                  />
                ))}
            </StyledMenuItem>
            <StyledMenuItem key="balance">
              <Popover
                content={<FormattedMessage id="balance.currentBalance" />}
                title=""
                placement="bottom"
                trigger="hover"
              >
                <StyledMenuTitle
                  style={{
                    width: mobileLayout ? '100%' : '20%',
                    justifyContent: mobileLayout && 'flex-start',
                    cursor: 'pointer',
                  }}
                  onClick={() => this.toggleBalance()}
                  hoverable
                >
                  <StyledMenuTitleValue>
                    {getSignByProfitType(2, defaultCurrencyId)}
                    {miniDashboard ? commaFormat(miniDashboard.balance) : 0}
                  </StyledMenuTitleValue>
                  <MenuTitleDescContainer className="title-link">
                    <MenuTitleDescRow>
                      <FormattedMessage id="dashboard.minidashboard.balance" default="Balance" />
                    </MenuTitleDescRow>
                  </MenuTitleDescContainer>
                </StyledMenuTitle>
              </Popover>
            </StyledMenuItem>
            <StyledMenuItem
              key="header-item-7"
              style={{
                flexGrow: 0.14,
                display: 'flex',
                justifyContent: 'space-around',
                flexDirection: mobileLayout && 'column',
                border: mobileLayout && 'none',
              }}
            >
              {!mobileLayout && <NotificationsMenu />}
              <SettingsButtonsContainer>
                {!initialized ? (
                  <Spin style={{ margin: 'auto', height: '22.5px' }} />
                ) : (
                  <React.Fragment>
                    <ButtonWithIcon
                      disabled={!initialized}
                      onClick={() => toggleSettings()}
                      iconType="settings"
                      iconSize="20"
                    />
                    <Popover
                      key="header-item-3"
                      content={
                        !firstName || !email ? (
                          <FormattedMessage id="common.hi" defaultMessage="Hi!" />
                        ) : (
                          <FormattedMessage
                            id="common.hiUser"
                            values={{ firstName, email }}
                            defaultMessage="Hi, {firstName}! ({email})"
                          />
                        )
                      }
                      title=""
                      placement="bottom"
                      visible={hoveringUserProfile && !isSettingsOpen}
                    >
                      <ButtonWithIcon
                        onMouseEnter={e => this.hoverOn(e, 'userProfile')}
                        onMouseLeave={e => this.hoverOff(e, 'userProfile')}
                        disabled={!initialized}
                        onClick={this.toggleUserSettings}
                        iconType="user"
                        iconSize="24"
                      />
                    </Popover>
                  </React.Fragment>
                )}
              </SettingsButtonsContainer>
              <Logout onClick={logout} />
              {isSettingsOpen &&
                (isBifmUser ? (
                  <BifmSettingsModal
                    visible={isSettingsOpen}
                    activeTab={ENUMS.SETTINGS_TABS.USER_PROFILE}
                    closeModal={() => toggleSettings()}
                  />
                ) : (
                  <SettingsModal
                    visible={isSettingsOpen}
                    activeTab={activeSettingsTab}
                    closeModal={() => toggleSettings()}
                  />
                ))}
              {loadedModal}
            </StyledMenuItem>
          </Menu>
          <SanityCheck
            toggleSanityCheck={this.toggleSanityCheck}
            open={isSanityCheckOpen}
            mobileLayout={mobileLayout}
          />
          {!isBifmUser && (
            <NoSubscriptionBlocker
              openSubscriptionSettings={() => toggleSettings(ENUMS.SETTINGS_TABS.SUBSCRIPTION)}
            />
          )}
        </AntHeader>
      </Fragment>
    );
  }
}

SalefreaksHeader.propTypes = {
  toastsStore: PropTypes.object,
  sessionStore: PropTypes.object,
  settingsStore: PropTypes.object,
  onboardingStore: PropTypes.object,
  dashboardStore: PropTypes.object,
  notificationsStore: PropTypes.object,
  localeStore: PropTypes.object,
  intl: PropTypes.object,
};

export default SalefreaksHeader;
